<template>
    <div class="yb-match-list column full-height relative-position match-tpl0">
    
      <!-- Loading -->
      <div class="refresh-mask absolute-full yb-flex-center" style="top: 36px;" v-show="reloading">
          <div class="img-loading custom-format-img-loading"></div>
        </div>

      <!-- Header -->
      <div class="scroll-fixed-headerA" style="z-index: 210;">
        <div class="c-match-list-header yb-flex-between">
        <div class="col-left vrow items-center" >
          <div data-v-532cf2cd="" class="list-title vrow items-center">
            <div data-v-532cf2cd="" class="title-text yb-font-bold ellipsis"> {{ lang.LivetvLang['LIVETV.SCHEDULE2'] }} ({{ selectedSportName }})</div>
          </div>
        </div>
        <div class="col-right yb-flex-center">
          <div class="select-wrap relative-position">
          </div>
          <div class="refresh-icon-wrap yb-flex-center select-btn refresh-tbl-wrap yb-hover-bg">
            <div class="c-refresh fit yb-flex-center cursor-pointer refresh-btn">
              <div class="icon-wrap" id="tblRefresh">
                <i aria-hidden="true" role="presentation" class="q-icon icon-tbl_refresh c-icon" style="font-size: 18px;" @click="refreshTbl()"></i>
              </div>
            </div>
          </div>

          <div class="unfold-btn" v-if="show_Fold" @click="foldSc()"> <!--sc only-->
            <span class="text">{{ lang.sportTableLang['SPORT_TABLE.OPEN'] }}</span>
            <i size="12px" class="icon-arrow q-icon c-icon"></i>
          </div>
        </div>
      </div>

      <!-- Sport icon -->
        <div class="c-match-list-filter">
            <div class="drag-scroll relative-position  filter-sports"> 
              <div class="hide-scrollbar" id="rb-sport-scroll">
                <div class="content" id="rb-scroll-content">
                  <!-- <div class="item column yb-flex-center" :class="getActive(rbAllSport)" @click="selectRBSport(rbAllSport)">
                    <div class="icon-wrap list-filter">
                      <span class="q-icon icon c-icon sport-img icon" style="width: 20px; height: 20px; background-position: 0px 0px;"></span>
                    </div>
                    <div class="name">{{ lang.sportTableLang['SPORT_TABLE.ALL'] }} </div>
                  </div> -->

                  <template v-for="sport in sportList">
                    <div class="item column yb-flex-center" :class="getActive(sport)" @click.prevent="selectRBSport(sport)">
                      <div class="icon-wrap list-filter">
                        <span class="q-icon icon c-icon sport-img icon" style="width: 20px; height: 20px;" :style="getBGPos(sport.sprtId)"></span>
                      </div>
                      <div class="name">{{sport.sprtLang}} </div>
                    </div>
                  </template>

                  <div style="min-width: 84px;"></div>
                  <div class="absolute-full resize-observer-wrap">
                    <div class="absolute-full expand"></div>
                    <div class="absolute-full shrink"></div>
                  </div>
                </div>
              </div>
              <div class="more-btn left" v-show="showLarrowRB" @click="clickMove($event, 'left')"></div>
              <div class="more-btn right" v-show="showRarrowRB" @click=" clickMove($event, 'right')"></div>
            </div>
          </div>

          <!-- Date -->
          <div class="c-match-list-filter date-filter early">
          <div class="tab-wrap fit relative-position" id="tabWrap">
            <div class="item-wrap relative-position" id="earlyDateScroll" :style="{'left':dateLeft+'px'}">
              <div :id="'tabDate-'+allDate" class="tab-item yb-flex-center" 
                  :class="{'active': allDate==selectedEarlyParlayDate }" 
                  @mouseover="highlightLine(allDate)" @mouseleave="highlightLine(selectedEarlyParlayDate)"
                  @click="changeEarlyParlayDate(allDate)">
                {{ lang.sportTableLang['SPORT_TABLE.ALL_DATES'] }}
              </div>
              <template v-for="(date, key) in earlyParlayDateList" >
                <div :id="'tabDate-'+key" class="tab-item yb-flex-center" 
                    :class="{'active': key ==selectedEarlyParlayDate}" 
                    @click="changeEarlyParlayDate(key)" 
                    @mouseover="highlightLine(key)" 
                    @mouseleave="highlightLine(selectedEarlyParlayDate)">
                  <template v-if="selectedBettype.betTypId=='5'">
                    {{ date | date('MMMDo') }}
                  </template>
                  <template v-else>
                    <template v-if="selectedLang != '1'">
                      <template v-if="selectedLang == '6'">
                        {{ date | date('Do MMMM(ddd)') }}
                      </template>
                      <template v-else>
                        {{ date | date('MMMDo') }}
                      </template>
                    </template>
                    <template v-else>
                      {{ date | date('DD/MM') }}
                    </template>
                  </template>
                </div>
              </template>
              <div :id="'tabDate-8'" class="tab-item yb-flex-center" 
                  :class="{'active': 8==selectedEarlyParlayDate}" 
                  @mouseover="highlightLine('8')" @mouseleave="highlightLine('8')"
                  @click="changeEarlyParlayDate(8)">
                {{ lang.sportTableLang['SPORT_TABLE.FUTURE'] }} 
              </div>
              <div class="line-wrap">
                <div class="line" id="earlyLine" style="width: 50px;"></div>
              </div>
            </div>
            <div class="left-btn btn" v-show="showLarrowEarly" @click="setDateArrow('L')">
              <div class="yb-icon-arrow"></div>
            </div>
            <div class="right-btn btn" v-show="showRarrowEarly" @click="setDateArrow('R')">
              <div class="yb-icon-arrow"></div>
            </div>
          </div>
        </div>
      </div>

    <div class="load-data-wrap sport-table-scroll col">
      <div style="height: 141px;"></div>
      <div id="div_show" name="div_show" v-if="liveEvent && (liveEvent.length > 0 || Object.keys(liveEvent).length > 0)" style="width: 99.5%" >
         <!-- Loading -->
         <div class="refresh-mask absolute-full yb-flex-center" style="top: 36px;" v-show="reloading">
          <div class="img-loading custom-format-img-loading"></div>
        </div>
        <template v-for="(eventObj, eventObjKey) in sortDate(liveEvent)" >
          <div class="list-live-wrap v-scroll-item relative-position sticky-wrap" style="height: fit-content !important; top: 138.5px;">
            <div class="list-card-inner">
              <div class="c-match-league match-tpl0-bg" :id="'title_wrap_'+eventObjKey" style="margin-bottom: 5px;" @click="showLeg(eventObjKey, true)" v-if="selectAllDate == true || selectFuture == true">
                <div class="tr-match-head">
                  <div class="leagues-wrap">
                    <i size="14px" class="icon-arrow q-icon c-icon"></i>
                    <div class="ellipsis-wrap" style="width: 122px;">
                      <div class="absolute-full">
                        <template v-if="selectedDate == 99 || selectedDate == 8 ">
                          <span class="ellipsis allow-user-select"> {{ getWeekdays(eventObj.date) }} {{ getFilterDate(eventObj.date) }}</span>
                        </template>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
             
          </div>
        </div>
        <div class="c-match-card relative-position evecard" :id="'list_wrap_'+eventObjKey" style="padding-bottom: 5px;">
                <div class="c-match-item m-otr tpl-18 csid-1">
                    <div class="play-wrap">
                      <template v-for="(event, eventKey) in sortEvent(eventObj.event)">
                        <div class="bet-list-wrap vrow">
                          <div class="bet-col schedule-list-col" style="width: 100% !important;">
                            <div
                              class="c-bet-item c-schedule-row yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                              <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                <div :id="'tv_FT_'+event.eveid"  @click="enterAllBet(event,2, true,event.rbstatus)" style="width: 100% !important;" name="live_tv" class="timetableBox" :class="event.rbstatus=='1' ? 'nowPlay' : ''">
                                    <div class="live_tv_icon"  v-if="event.rbstatus=='1'"></div>
                                    <div class="live_tv_time" v-else>{{ getFilterTime(event.dt) }}</div>
                                    <div  :class="drawclass(event.sptid)"></div>
                                    <div class="tv_game_name"><span><span v-html="event.tacapt"></span> vs <span v-html="event.tbcapt"></span></span></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                </div>
            </div>
      </template>
      </div>
      <div data-v-21f17103="" class="column empty fit" v-else>
         <!-- Loading -->
         <div class="refresh-mask absolute-full yb-flex-center" style="top: 36px;" v-show="reloading">
          <div class="img-loading custom-format-img-loading"></div>
        </div>
          <div data-v-31145778="" data-v-21f17103="" class="wrap empty-wrap" style="margin-bottom: 0px;">
            <div data-v-31145778="" class="img light" style="width: 180px; height: 180px; margin: auto;"></div>
            <div data-v-31145778="" class="text-center">{{ lang.configLang['CONFIG_LANG.LBL_NO_LIVE'] }}</div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {
    mapGetters
  } from 'vuex'
 
  import EventBus from '@/vue/events/event-bus'
  import moment from 'moment'
  import sportTable from '../sport/sportTable'

  export default {
    data(){
      return{
        cookielang: window._cookie,
        lang: window.lang,
        getDate: window.dates,
        selectedDate: 99,
        sportId: (window.sport_feature) ? this.$store.getters.sportList[0]['sprtId'] : 'N1',
        type: 'livetv',
        todayEventDate: null,
        token: window.token,
        cookies_lang: window._cookie,
        sportCap:'',
        tvlink: null,
        windowWidth: window.innerWidth,
        showLarrowRB: true,
        showRarrowRB: true,
        showLarrowEarly: false,
        showRarrowEarly: true,
        dateLeft: 0,
        rbSportLeft: 0,
        showGameBanner: window._gameBanner? true:false,
        gameBannerImage: window._gameBannerImage,
        allDate: '99',
        selectedLang: window._langid,
        selectedSportId: (window.sport_feature) ? this.$store.getters.sportList[0]['sprtId'].replace('N', '') : '1',
        reloading: true,
        selectAllDate:true,
        selectFuture:false,
        rbAllSport: {
          "sprtId": "G98",
        },
        selectedSportName: this.$store.getters.sportList[0]['sprtLang'],//window.lang.configLang['CONFIG_LANG.LBL_GAME_SOCCER'],
        liveEve:  this.$store.getters.liveEvent,
        sportBettypeList: window.sportBettypeList,
        timerSeconds: 60,
        selectedEvent:null,
      }
    },
    components: {
      sportTable,
    },
    methods: {
      foldSc(){
        this.$store.commit('SHOW_UNFOLD', true)
        this.$store.commit('SHOW_FOLD', false)
        this.$store.commit('UNFOLD_ALLSC', false)
        var temp = this.$store.getters.selectedBettype
        var element = document.getElementById('AllBetScrollfirstEvent');
        element.classList.remove('hide');
        this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(temp))
      },
      getActive(sport){
        var str = 'no-active'
        if((this.sportId == this.rbAllSport.sprtId && this.sportId != sport.sprtId) || this.sportId == sport.sprtId ){
          str = 'active'
        }
        return str 
      },
      showLeg(key, isRB) {
        var closeList = document.getElementById('list_wrap_'+key);
        var closeTitle = document.getElementById('title_wrap_'+key);

        closeList.classList.toggle('hide');
        closeTitle.classList.toggle('leagues-pack');
      },
      clickMove(e, direction){
        var VUE = this
        var holderWidth = $('#rb-sport-scroll').width()
        var totalWidth = 0
        var count = 0
        $("#rb-scroll-content > .item.column").each(function() {
          totalWidth = totalWidth + $(this).outerWidth();
        });
        
        var setI = setInterval(function () {
          count++
          if(count > 12){
            clearInterval(setI)
          }

          VUE.rbSportLeft += (direction=='right') ? 15 : -15
          document.getElementById("rb-sport-scroll").scrollLeft = VUE.rbSportLeft

          var calc = totalWidth - VUE.rbSportLeft
          VUE.showLarrowRB = (VUE.rbSportLeft>0) ? true : false
          VUE.showRarrowRB = (calc>holderWidth) ? true : false
        }, 16);
      },
      enterAllBet(event,startTv,isRB=false,rbStatus) {
        this.selectedEvent = event;
        this.$store.commit('RIGHT_BOARD_CHG', event)
        this.$store.commit('LIVE_MATCH', event)
        this.$store.commit('IS_OPEN_TV', startTv)
        EventBus.$emit('refreshOdd', true);

        if(rbStatus == 1){
            this.$store.commit('SELECTED_MATCHALLBET', true)
            this.$store.dispatch('getMatchAllBet', {
            event: event,
            isRB: (rbStatus==1) ? true : false,
            token: token.arr_8,
            loadTemplate: startTv  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
          })
        }
      },
      selectRBSport(sport){
        this.sportId = (sport.sprtId==this.rbAllSport.sprtId) ? this.rbAllSport.sprtId : sport.sprtId
        if(this.sportId == 'G98'){
          this.selectedSportName = window.lang.sportTableLang['SPORT_TABLE.ALL']
        }else{
          this.selectedSportName = sport.sprtLang
        }
       
        this.getEventsOdds();
      },
      changeEarlyParlayDate(dateKey) {
        EventBus.$emit('refreshOdd', true);
        this.$store.commit('SELECTED_PAGE', 1)
        this.$store.commit('SELECTEDEARLYPARLAYDATE', dateKey)
        this.selectedDate  = dateKey;
      
        if(dateKey == '99'){
          this.selectAllDate = true
        }else{
          this.selectAllDate = false
        }

        if(dateKey == '8'){
          this.selectFuture = true
        }else{
          this.selectFuture = false
        }

        this.getEventsOdds();
      },
      highlightLine(val){
        this.$nextTick(() => {
          var tabElement = $("#tabDate-"+val).first();
          if (tabElement.length > 0) {
            var position = tabElement.position();
            if (position) {
                var center = position.left + tabElement.outerWidth()/2 - 25;
                $('.c-match-list-filter .line').css('transform','translateX('+ center +'px)');
            }
          }
        });
      },
      setDateArrow(direction){  //early date left right arrow
        if(direction=='default'){
          this.dateLeft = 0
          this.showLarrowEarly = false
          this.showRarrowEarly = true
          return
        }
        this.dateLeft += (direction=='R') ? -100 : 100

        var totalWidth = 0
        var holderWidth = $('#tabWrap').width()
        this.showLarrowEarly = (this.dateLeft<0) ? true : false

        $("#earlyDateScroll > .tab-item").each(function() {
          totalWidth = totalWidth + $(this).outerWidth();
        });
        var calc = totalWidth + this.dateLeft
        this.showRarrowEarly = (calc>holderWidth) ? true : false
      },
      getBGPos(sprtId){
        var a = ''
        if(sprtId=='N1'){         //Soccer
          a = 'background-position: 0px -28.33px;'
        }else if(sprtId=='G1' || sprtId=='N2'){   //BK
          a = 'background-position: 0px -85px;'
        }else if(sprtId=='N3'){   //Tennis
          a = 'background-position: 0px -538.33px;'
        }else if(sprtId=='N21'){   //Volley
          a = 'background-position: 0px -170px;'
        }else if(sprtId=='N12'){  //Badminton
          a = 'background-position: 0px -623.33px;'
        }else if(sprtId=='N15'){  //Snooker
          a = 'background-position: 0px -425px;'
        }else if(sprtId=='G2'){
          a = ''
        }else if(sprtId=='N7'){  //cricket
          a = 'background-position: 0px -1445px;'
        }else if(sprtId=='N14'){  //ice hockey
          a = 'background-position: 0px -57px;'
        }else if(sprtId=='N13'){  //Am fooball
          a = 'background-position: 0px -114px;'
        }else if(sprtId=='N19'){  //handball
          a = 'background-position: 0px -368.5px;'
        }else if(sprtId=='N20'){  //Esport
          a = 'background-position: 0px -142px;'
        }else if(sprtId=='N23'){  //Baseball
        a = 'background-position: 0px -793px;'
        }else{
          a = 'background-position: 0px -85px;'
        }
        return a
      },
      drawclass(gid){
        var classss='ball_icon_';
        if(gid==1){
          classss+='ft'
        }else if(gid==2 || gid==13){
          classss+='bk'
        }else if(gid==3){
          classss+='tn'
        }else if(gid==21){
          classss+='vb'
        }else if(gid==23){
          classss+='bs'
        }else if(gid==12){
          classss+='bm'
        }else{
          classss+='op'
        }
        return classss
      },
      getWeekdays(dt){
          if(this.cookies_lang == 'en_US'){
              return moment(dt).format('ddd')
          }else{
              return moment(dt).format('dddd')
          }
      },
      getMonth(dt){
          if(this.cookies_lang == 'en_US'){
              return moment(dt).format('MMM')
          }else{
              return moment(dt).format('MMMM')
          }
      },
      selDate(key){
        this.selectedDate = key;
        this.getEventsOdds(token.arr_6)
      },
      getFilterDate(dt){
        return dt
      },
      matchDateCheck(date){
        return moment.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss")
      },
      getFilterTime(dt){
        if(this.$store.getters.timeZone.default != 'GMT-4'){
          let nDate = this.getNewDate(dt)
          let nTime = this.getTime(dt)

          return nDate + ' ' + nTime
        }else{
          return new moment(dt).format("HH:mm")
        }
      },
      getNewDate(dt){
        dt = this.matchDateCheck(dt)
        if(this.cookies_lang=='zh_TW' || this.cookies_lang == 'zh_CN'){
          return new moment(dt).format("MM/DD")  
        }
        return new moment(dt).format("DD/MM")
      },
      getTime(dt){
        dt = this.matchDateCheck(dt)
        return new moment(dt).format("HH:mm")
      },
      getEventsOdds(token_val=''){ 
        EventBus.$emit('refreshOdd', true);
        this.reloading = true;
        if(token_val==''){
          token_val = token.arr_2
        }

        this.$store.dispatch('getLiveSchedule', {
          date : this.selectedDate,
          sportId : this.sportId,
          token: token_val
        })
        .then(() => {     
          setTimeout(() => {
            this.reloading = false;
            this.liveEve = this.$store.getters.liveEvent ;
          }, 500); 
        })
      },
      sortEvent(event){
        return _.sortBy(event,['dt'])
      },
      sortDate(event){
        var datels = Object.keys(event)

        var orderedDate = _.orderBy(datels)

        var orderedEvent = _.map(orderedDate, (date)=> {
          return  {
            'event': event[date],
            'date' : date
          }
        })
        return orderedEvent
      },
      onResize() {
        this.windowWidth = window.innerWidth
      },
      getFilterEventList(){
        this.$store.dispatch('getFilterEventList',{
          'sportid': this.selectedSportId
        })
        this.reloading = false
      },
      arrayToObject(array) {
        return array.reduce((acc, curr) => {
            return Object.assign(acc, curr);
        }, {});
      },
      refreshTbl(token_val) {
        $('#tblRefresh').addClass('loading-static-animation')

        this.timerSeconds = 30;
        this.reloading = (token_val == token.arr_1 || token_val == token.arr_5) ? false : true
        if (this.selectedMatchAllBet) {
          this.reloadAllBetTable(token_val)
          
        this.$store.dispatch('getLiveSchedule', {
          date : this.selectedDate,
          sportId : this.sportId,
          token: token_val
        })
        } else {
          this.getEventsOdds(token_val)

        }
      },
      reloadAllBetTable(token_val = '') {
      if (token_val == '') {
        token_val = token.arr_5
      }
      // this.reloadingPer = '25%';
      this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList)
      let Vue = this;
      if( this.selectedEvent !== null ){
        if(this.selectedEvent.rbstatus == 1 ){
          this.$store.dispatch('getMatchAllBet', {
            event: this.selectedEvent,
            isRB:  true,
            token: token.arr_8,
            loadTemplate: 2,
            notLoadTV:true,
            callback: ((res) => {
              // Vue.timerSeconds = Vue.getMarketTimer(Vue.$store.getters.selectedMarket)

              Vue.startTimer()
              Vue.mainMarketList = _.cloneDeep(Vue.$store.getters.sortedMatchEventList)

              Vue.$nextTick(() => {
                EventBus.$emit('diffOdd', Vue.cloneEventAllBet)
              })
              Vue.reloading = false
              $('#tblRefresh').removeClass('loading-static-animation')
            })
          })
        }else{
          this.$store.dispatch('getMatchAllBet', {
            event: this.selectedEvent,
            isRB:  false,
            token: token.arr_8,
            loadTemplate: 1,
            notLoadTV: true,
            callback: ((res) => {
              // Vue.timerSeconds = Vue.getMarketTimer(Vue.$store.getters.selectedMarket)

              Vue.startTimer()
              Vue.mainMarketList = _.cloneDeep(Vue.$store.getters.sortedMatchEventList)

              Vue.$nextTick(() => {
                EventBus.$emit('diffOdd', Vue.cloneEventAllBet)
              })
              Vue.reloading = false
              $('#tblRefresh').removeClass('loading-static-animation')
            })
          })
        }
      }
      
      // this.reloadingPer = '80%';
      
    },
    getMarketTimer(selMarket) {

      if (this.$store.getters.open_RBMarket) {
        return this.rbTimer
      } else if (selMarket == this.$store.getters.market.earlyMarket.key) {
        return this.earlyTimer
      } else if (selMarket == this.$store.getters.market.tdyMarket.key) {
        return this.todayTimer
      }
    },
      startTimer() {
        this.timerSeconds = 30;
        if (this.timerId == null) {
          this.timerId = setInterval(() => {
            if (this.timerSeconds - 1 < 0) {
              // this.reloadTable(token.arr_1)
              this.refreshTbl(token.arr_1)
            } else {
              this.timerSeconds -= 1;
            }
          }, 1000);
        }
      },
      clearTimer() {
        clearInterval(this.timerId)
        this.timerId = null
      },
      refreshTimer() {
        this.clearTimer()
        this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
        // this.timerSeconds = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 180
        this.startTimer()
      },
    },
    watch: {
      liveEve: {
          handler(newData,oldData) {
            var sortEve = _.sortBy(newData, [event => new Date(event.dt)]);
            if (sortEve.length > 0) {
                var firstValue =  Object.values(sortEve[0])[0];
              if( (typeof firstValue === 'object' && Object.keys(firstValue).length > 0) ){
                // && firstValue.rbstatus == 1
                var eveDate = moment(firstValue.dt, "YYYY-MM-DD"); 
                var DateNow = moment().utcOffset("-04:00").startOf('day').valueOf(); 

                if (eveDate.isAfter(DateNow, 'day')) {
                  this.$store.commit('SELECTED_MARKET', "2")
                } 
                else{
                  if(firstValue.sptid == 2){
                    this.$store.commit('SELECTED_MARKET', "3")
                  }else{
                    this.$store.commit('SELECTED_MARKET', "1")
                  }
                }

                this.$store.commit('RIGHT_BOARD_CHG', firstValue)
                this.$store.commit('LIVE_MATCH', firstValue)
                this.$store.commit('IS_OPEN_TV', 1)
              
                this.selectedEvent = firstValue;
                EventBus.$emit('refreshOdd', true);
                this.$store.dispatch('getMatchAllBet', {
                  event: firstValue,
                  isRB: (firstValue.rbstatus==1) ? true : false,
                  token: token.arr_8,
                  loadTemplate: 1  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
                })
              }
            }
          },
          deep: true
      }
    },
    beforeMount: function () {
      // this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
      $('body').css("background-color", "white");
      this.getFilterEventList()
      this.startTimer()
    },
    created(){
    },
    mounted() {
      this.getEventsOdds(token.arr_2)
      window.addEventListener('resize', this.onResize);

      EventBus.$on('callLivetv', () => {
        this.selectedDate = 99;
        this.sportId = (window.sport_feature) ? this.$store.getters.sportList[0]['sprtId'] : 'N1';
        this.$store.commit('SELECTEDEARLYPARLAYDATE', 99)

        this.highlightLine(99)
        this.getEventsOdds()
      })
    },
    destroyed() {
      this.clearTimer()
    },

    computed: {
      ...mapGetters([
        'sortedEvents',
        'arr_selectedTemplate',
        'liveEvent',
        'livetv',
        'sportList',
        'selectedEarlyParlayDate',
        'earlyParlayDateList',
        'selectedBettype',
        'sortedMatchEventList',
        'selectedMarket',
        'liveSchedule',
        'show_Fold',
        'selectedMatchAllBet',
        'openTv',
        'timeZone',
      ]),
    }
  }
</script>
<style lang="scss">

.gridContainer{
    position: relative;
}
.LayoutDiv1_contact{
   line-height : 55px;
}
@import "~@/styles/base/global";
</style>


// WEBPACK FOOTER //
// resources/wob/vue/apps/livetv/livetvEventsList.vue